import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useParams } from "react-router-dom";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import GenerateLinkButton from "../components/SmartLink.jsx";
import VideoCard from "../components/TopVideo.jsx";
import Float from "../components/side_button";
import Floattwo from "../components/side_button2";
import { getURLandredirect } from "../helper/api";
import PageHead from "../components/Splash/PageHead";
import { getSuggestions, GetLatestBlogs } from "../helper/api";
import ytLogo from "../assets/yt-logos.avif";
import { Trophy } from "lucide-react";
import homeImage from "../assets/footer-space-man.avif";
import UserProfile from "../components/UserProfile";
/* import ChristmasLights from "../components/ChristmasLights"; */
import Footer from "../components/Footer";
import AdsterraAd from "../components/Adsterads";
import G13Ads from "../components/g13ads";
/* import Snowfall from "react-snowfall"; */
/* import tree from "../assets/tree.avif";
import Snowman from "../assets/SnowMan.avif"; */
/* import light from "../assets/Glight.avif"; */

const getUserAgent = () => {
  let agent = navigator.userAgent.toLowerCase();
  let result = "";
  if (agent.includes("android")) {
    result = "android";
  } else if (agent.includes("iphone")) {
    result = "ios";
  } else {
    result = "desktop";
  }
  return result;
};
const Splash = () => {
  const [buttonVisible, setButtonVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [buttonText, setButtonText] = useState("Redirecting in 3");
  const [top10, settop10] = useState([]);
  const [showTop, setshowTop] = useState(false);
  const [TopVideo, setTopVideo] = useState([]);
  const [Dom, setDom] = useState("");
  const [showCancelButton, setShowCancelButton] = useState(true); // Loader state for UI feedback
  const [state, setState] = useState({
    intentvalue: "",
    original_url: "",
    linkMetadata: {},
    seconds: 3,
    redirectText: "Redirecting in ",
    video_id: "",
    showImage: false,
  });
  const [videos, setvideos] = useState({
    suggestions: { links: [] },
    loading: true,
  });
  const timerIntervalRef = useRef(null);
  const continueButtonRef = useRef(null);
  const showTopref = useRef(null);
  const { apptype, shorturl } = useParams();

  const [activeItem, setActiveItem] = useState("Home");
  const [showGenerateLink, setShowGenerateLink] = useState(false);
  const history = useHistory();
  const location = useLocation();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const navItems = [
    {
      name: "Imagine",

      route: "/",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
          />
        </svg>
      ),
    },
    {
      name: "Top 10",
      route: null,
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
          />
        </svg>
      ),
    },
    {
      name: "Link",
      route: null, // No route since it triggers a component
      icon: <span className="text-lg font-bold">Å</span>,
    },
    {
      name: "Study",
      route: "/blog",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
          />
        </svg>
      ),
    },

    {
      name: "Speak",
      route: "/contact-us",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      ),
    },
  ];

  useEffect(() => {
    const currentRoute = location.pathname;
    setDom(currentRoute);
    const activeNavItem = navItems.find((item) => item.route === currentRoute);
    if (activeNavItem) {
      setActiveItem(activeNavItem.name);
    }
  }, [location.pathname, navItems]);

  const handleNavigation = (route, name) => {
    if (name === "Link") {
      setShowGenerateLink(true);
    } else if (name === "Top 10") {
      setshowTop(!showTop);
      showTopref.current.focus();
    } else if (route?.startsWith("http")) {
      window.location.href = route;
    } else {
      history.push(route);
    }
  };

  const updateScreenSize = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      isSmallScreen: window.innerWidth <= 655,
    }));
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const debouncedResize = setTimeout(() => {
        updateScreenSize();
      }, 200);

      return () => clearTimeout(debouncedResize); // Clear timeout if the resize happens before 200ms
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [updateScreenSize]);

  const startTimer = useCallback((app_intend, click_link) => {
    if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);

    timerIntervalRef.current = setInterval(() => {
      setState((prevState) => {
        if (prevState.seconds <= 1) {
          clearInterval(timerIntervalRef.current);
          setShowCancelButton(false);
          click_link.setAttribute("href", app_intend);
          const agent = getUserAgent();
          if (agent === "desktop") {
            const newTab = window.open("", "_blank");
            if (newTab) {
              newTab.document.write(
                `
                <html>
                <head>
                <title>Redirecting...</title>
                <body>
                <a id="redirectLink" href="${app_intend}">Click here if not redirected</a>
                <script>
                document.getElementById('redirectLink').click();
                </script>
                <script data-cfasync="false" type="text/javascript" id="clever-core">
 /* <![CDATA[ */
     (function (document, window) {
         var a, c = document.createElement("script"), f = window.frameElement;
 
         c.id = "CleverCoreLoader89618";
         c.src = "https://scripts.cleverwebserver.com/b808f0a1150069f8ab4947f2d536ab0a.js";
 
         c.async = !0;
         c.type = "text/javascript";
         c.setAttribute("data-target", window.name || (f && f.getAttribute("id")));
         c.setAttribute("data-callback", "put-your-callback-function-here");
         c.setAttribute("data-callback-url-click", "put-your-click-macro-here");
         c.setAttribute("data-callback-url-view", "put-your-view-macro-here");
         
 
         try {
             a = parent.document.getElementsByTagName("script")[0] || document.getElementsByTagName("script")[0];
         } catch (e) {
             a = !1;
         }
 
         a || (a = document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]);
         a.parentNode.insertBefore(c, a);
     })(document, window);
 /* ]]> */
 </script>
                </body>
                </html>
              `
              );
              newTab.document.close();
            }
          } else {
            click_link.click();
          }
          console.log(prevState);
          return {
            ...prevState,
            seconds: 0,
            redirectText: "Redirecting...",
            showImage: true,
          };
        }

        return { ...prevState, seconds: prevState.seconds - 1 };
      });
    }, 1000);

    // Trigger manual click in case automatic click fails
    setTimeout(() => {
      click_link.onclick = (e) => {
        e.preventDefault();
        window.open(app_intend, "_self");
      };
    }, 5000);
  }, []);

  const handleApiDataLoaded = useCallback(() => {
    setLoading(false);
    // Hide loader once data is loaded
  }, []);

  useEffect(() => {
    setLoading(true); // Show loader when API starts fetching
    let app_intend = "";
    const click_link = document.getElementById("abcd");
    getURLandredirect(apptype, shorturl)
      .then((res) => {
        if (!res) return;
        const linkMeta = res.data.metadata || {};
        const videoId = extractVideoId(res.data.originalURL);
        /*  console.log("API Response:", res.data); */
        if (linkMeta) {
          const metadata = {
            title: linkMeta.title || "Get Smart Links with AppOpener",
            image: linkMeta.image || linkMeta.thumbnail || homeImage,
            description:
              linkMeta.description || "Generate Smart Links with AppOpener",
            videoId: linkMeta.videoId,
          };

          /*   console.log("Link Metadata:", metadata); */

          setState((prevState) => ({
            ...prevState,
            linkMetadata: metadata,
            intentvalue: res.data.app_intend,
            original_url: res.data.originalURL,
            video_id: videoId,
          }));
          /* 
          console.log("Intent Value:", res.data.app_intend);
          console.log("Original URL:", res.data.originalURL);
          console.log("Video ID:", videoId); */
        }
        app_intend = res.data.app_intend;

        if (app_intend === "Desktop" || app_intend === "Mobile") {
          app_intend = res.data.originalURL;
        }

        setButtonVisible(true);
      })
      .finally(() => {
        setLoading(false);
        if (app_intend && click_link) {
          startTimer(app_intend, click_link);
        }
      });
  }, [apptype, shorturl, startTimer]);

  const extractVideoId = (url) => {
    const urlObj = new URL(url);
    if (url.includes("youtu.be")) {
      return urlObj.pathname.substr(1);
    }
    if (url.includes("live") || url.includes("shorts")) {
      return urlObj.pathname.split("/")[2];
    }
    return urlObj.searchParams.get("v");
  };
  const handleCancel = () => {
    clearInterval(timerIntervalRef.current);
    setButtonText("Press to Continue");
    setShowCancelButton(false);
  };

  const handleButtonClick = () => {
    if (buttonText === "Press to Continue") {
      const click_link = document.getElementById("abcd");
      click_link.click();
    }
  };

  useEffect(() => {
    if (videos?.suggestions?.links?.length > 0) {
      // Limit to only 3 videos
      const TopVideos = videos.suggestions.links.slice(0, 5);
      const top10 = videos.suggestions.links.slice(0, 10);
      setTopVideo(TopVideos); // Start from the first video
      settop10(top10);
    }
  }, [videos]);

  useEffect(() => {
    const getSugBlog = async () => {
      try {
        let suggestionsData = await getSuggestions();
        if (suggestionsData?.links?.length) {
          suggestionsData.links.sort((a, b) => b.clicks - a.clicks);
        }
        setvideos({
          suggestions: suggestionsData || { links: [] },
          loading: false,
        });
      } catch (err) {
        console.log("Error fetching data:", err);
        setState((prevState) => ({ ...prevState, loading: false }));
      }
    };
    getSugBlog();
  }, []);

  // Memoize computed values to prevent unnecessary recalculations
  const redirectContent = useMemo(() => {
    const commonClass = "flex flex-row items-center justify-center space-x-2";

    if (buttonText === "Press to Continue") {
      return (
        <div className={commonClass}>
          <img src={ytLogo} alt="App Logo" className="w-5 h-5" />
          <p className="text-white font-semibold text-base pt-2">
            Press to Continue
          </p>
        </div>
      );
    }

    return state.showImage ? (
      <div className={commonClass}>
        <img src={ytLogo} alt="App Logo" className="w-5 h-5" />
        <p className="text-white font-semibold text-base pt-3">
          Press to Continue
        </p>
      </div>
    ) : (
      <p className="text-white font-semibold text-base">
        {state.redirectText} {state.seconds}
      </p>
    );
  }, [buttonText, state.showImage, state.redirectText, state.seconds]);

  return (
    <div className="bg-back-main/70">
      <AdsterraAd />
      {loading}
      {state.linkMetadata && <PageHead metadata={state.linkMetadata} />}
      <nav className="shadow-md">
        {
          <UserProfile
            url={state.original_url}
            video_id={state.video_id}
            onApiDataLoaded={handleApiDataLoaded}
            onCancelRedirect={handleCancel}
          />
        }
      </nav>

      <main className="flex flex-col items-center px-2">
        <div className="w-full max-w-4xl mx-auto mt-3 mb-2">
          {state.video_id && (
            <div className="relative group overflow-hidden rounded-xl">
              <div className="relative aspect-video overflow-hidden bg-card rounded-xl shadow-lg">
                {state.linkMetadata.image && (
                  <iframe
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out"
                    src={`https://www.youtube.com/embed/${
                      state.linkMetadata.videoId || state.video_id
                    }`}
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                )}
              </div>
            </div>
          )}

          <div className="w-full flex flex-col items-center">
            <a
              className="w-full max-w-4xl no-underline"
              id="abcd"
              ref={continueButtonRef}
            >
              <button
                onClick={handleButtonClick}
                className="gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-10 px-4 py-2 mt-3 mb-1 w-full bg-[#42b883] hover:bg-[#42b883]/90 text-white flex items-center justify-center group"
              >
                {redirectContent}
              </button>
            </a>

            {buttonVisible && showCancelButton && (
              <button
                onClick={handleCancel}
                className="border-2 border-white px-2 rounded-lg text-white font-semibold text-base shadow-sm hover:underline"
                id="cancel"
              >
                Cancel
              </button>
            )}
          </div>
          <nav
            style={{
              zIndex: "10000",
            }}
            className="bg-back-main text-white w-full mb-1 mt-3 rounded-lg shadow-lg"
          >
            <div className="flex justify-around items-center h-16 space-x-2 px-2">
              {navItems.map((item) => {
                const isActive = activeItem === item.name;
                return (
                  <div
                    key={item.name}
                    className={`flex flex-col justify-center px-2 items-center rounded-lg overflow-hidden ${
                      isActive
                        ? "text-indigo-600 font-semibold"
                        : "hover:bg-[#42b880]/10 cursor-pointer text-[#42b883]"
                    }`}
                    onClick={() => handleNavigation(item.route, item.name)}
                  >
                    <button className="flex items-center justify-center p-0.5 rounded-full transition-colors text-sm sm:text-base w-10 h-10">
                      {item.icon}
                    </button>
                    <span
                      className={`text-xs sm:text-sm ${
                        isActive
                          ? "text-indigo-600 font-semibold"
                          : "text-[#42b883]"
                      }`}
                    >
                      {item.name}
                    </span>
                  </div>
                );
              })}
            </div>
          </nav>
          {showGenerateLink && (
            <div className="bg-white p-4 md:p-6">
              <GenerateLinkButton />
            </div>
          )}
        </div>
        <div className="w-full max-w-3xl flex justify-center mb-4">
          <div className="w-full max-w-4xl">
            {/* Header */}
            <div className="flex flex-row font-bold text-lg sm:text-xl mt-2 text-[#3EA979]">
              <Trophy size={24} />
              <p className="ml-2 text-white">Leaderboard</p>
            </div>

            {/* Table Container */}
            <div className="bg-gray-800 rounded-xl shadow-md overflow-hidden">
              {/* Table Header */}
              <div className="grid grid-cols-12 items-center px-4 py-2 bg-gray-700 border-b border-white">
                <div className="col-span-2 text-white font-semibold text-sm sm:text-base">
                  Rank
                </div>
                <div className="col-span-7 text-white font-semibold text-sm sm:text-base">
                  Video
                </div>
                <div className="col-span-3 text-white font-semibold text-sm sm:text-base text-right">
                  Points
                </div>
              </div>

              {/* Table Rows */}
              {TopVideo.map((item, index) => (
                <a
                  key={index}
                  href={item["smart_link"]}
                  className="no-underline block transition hover:bg-gray-700"
                >
                  <div className="grid grid-cols-12 items-center px-4 py-3 border-b border-gray-700">
                    {/* Rank */}
                    <div className="col-span-2 flex items-center justify-start">
                      <div
                        className={`w-8 h-8 flex items-center justify-center text-sm font-bold rounded-full ${
                          index === 0
                            ? "bg-yellow-500 text-black"
                            : index === 1
                            ? "bg-slate-500 text-white"
                            : index === 2
                            ? "bg-[#5a4e1b] text-white"
                            : "bg-gray-600 text-white"
                        }`}
                      >
                        {index + 1}
                      </div>
                    </div>

                    {/* Video Title */}
                    <div className="col-span-7 truncate text-white text-sm sm:text-base font-medium">
                      {item.metadata.title}
                    </div>

                    {/* Points */}
                    <div className="col-span-3 text-right font-semibold text-white text-sm sm:text-base">
                      {item.clicks * 3}
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
        <div ref={showTopref} className="w-full px-2" tabIndex={0}>
          {showTop &&
            top10.map((item, index) => (
              <a href={item.smart_link} key={index} className="no-underline">
                <VideoCard
                  rank={index + 1}
                  title={item.metadata.title}
                  thumbnail={item.metadata.image}
                  description={item.metadata.description}
                />
              </a>
            ))}
        </div>
      </main>
      <Floattwo />
      <Footer />
    </div>
  );
};

export default Splash;
